import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { getLabels, delLabel } from '@/api/label';
import LabelClass from '@/model/LabelClass';
import LabelListClass from '@/model/LabelListClass';
import moment, {Moment} from 'moment';
import { isOverTime } from '@/utils/other';

type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ILabelClass = ILabel.IModel.ILabelClass;

const defaultColors: string[] = [
  '#61bd4f',
  '#f2d600',
  '#ff9f1a',
  '#eb5a46',
  '#c377e0',
  '#0079bf',
  '#00c2e0',
  '#51e898',
  '#ff78cb',
  '#344563',
];

export interface ILabelState {
  labels: ILabelClass[];
  labelModal: {
    visible: boolean;
    isCreate: boolean;
  };
  labelColors: string[];
  loadedTime: Moment | null;
}
@Module({ dynamic: true, store, name: 'label' })
class Label extends VuexModule implements ILabelState {
  public labels: ILabelClass[] = [];
  public labelList: ILabel.IModel.ILabelListClass = new LabelListClass();
  public labelModal = {
    visible: false,
    isCreate: false,
  };
  public labelColors: string[] = defaultColors;
  public currentLabel: ILabelClass | null = null;
  public loadedTime: Moment | null = null;

  @Action({rawError: true})
  public GetLabels(force: boolean = false): Promise<string> {
    return new Promise((reslove, reject) => {
      const minute = force ? -1 : 3;
      if (!isOverTime(this.loadedTime, minute)) {
        reslove('Success');
        return;
      }
      getLabels({
        pubilc: true,
        active: true,
      }).then((res) => {
        this.SET_LABELS(res.data);
        reslove('Success');
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  @Action
  public ToggleLabelModalVisible() {
    this.TOGGLE_LABELMODAL_VISIBLE();
  }
  @Action({rawError: true})
  public DeleteLabel(id: string): Promise<string> {
    return new Promise((reslove, reject) => {
      delLabel(id).then((res) => {
        this.DELETE_LABEL(id);
        reslove('Success');
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  @Action
  public InitLabelModal(label?: ILabelClass) {
    this.SET_LABELMODAL(label);
    this.SET_CURRENTLABEL(label);
  }
  @Action({rawError: true})
  public AddLabelToList(label: ILabelClass) {
    this.ADD_LABEL_TO_LIST(label);
  }
  @Mutation
  private SET_LABELS(labels: ILabelInfo[]) {
    this.loadedTime = moment();
    this.labels = labels.map((label) => {
      return new LabelClass(label);
    });
  }
  @Mutation
  private TOGGLE_LABELMODAL_VISIBLE() {
    this.labelModal.visible = !this.labelModal.visible;
  }
  @Mutation
  private SET_LABELMODAL(label?: ILabelInfo) {
    if (label) {
      this.labelModal.isCreate = false;
    } else {
      this.labelModal.isCreate = true;
    }
  }
  @Mutation
  private DELETE_LABEL(id: string) {
    this.labels = this.labels.filter((label) => label.id !== id);
  }
  @Mutation
  private ADD_LABEL_TO_LIST(label: ILabelClass) {
    this.labels.unshift(label);
  }
  @Mutation
  private SET_CURRENTLABEL(label?: ILabelClass) {
    if (label) {
      this.currentLabel = label;
    } else {
      this.labelList.createLabel();
      this.currentLabel = this.labelList.labelForCreate;
    }
  }
}
export const LabelModule = getModule(Label);
